export const GET_LANGUAGES = 'GET_LANGUAGES';
export const GET_LANGUAGE_BY_ID = 'GET_LANGUAGE_BY_ID';
export const UPDATE_LANGUAGE = 'UPDATE_LANGUAGE';
export const DELETE_LANGUAGE = 'DELETE_LANGUAGE';
export const CREATE_LANGUAGE = 'CREATE_LANGUAGE';
